import { useMemo } from 'react'
import useSWR from 'swr'
import { useToken } from './auth/token'
import API from '../../utils/api'

export const useUserGroups = (refresh = 0) => {
	const { data: token } = useToken()

	// TableAPI와 정확히 동일한 URL 구성
	const dateurl = '\n\t'  // TableAPI의 dateurl 기본값
	const groupurl = '' // 그룹 검색 없음
	const maxData = 50
	const page = 1

	const swrKey = token
		? `/admin/usergroup?t=${refresh}${dateurl}&maxData=${maxData}&page=${page}${groupurl}`
		: null

	// SWR 캐시에서 데이터를 읽어오기 (fetcher 없이 - TableAPI와 캐시 공유)
	const { data: response, mutate, isLoading, error } = useSWR(swrKey, null, {
		revalidateOnFocus: false,
		dedupingInterval: 2000
	})

	const groups = useMemo(() => {
		console.log('Processing groups data:', response)

		// TableAPI 응답 구조: {list: Array, maxPage: number, totalCount: number}
		if (response?.list && Array.isArray(response.list)) {
			console.log('Groups found:', response.list.length, response.list)
			// 그룹 데이터 구조 상세 로깅
			response.list.forEach((group, index) => {
				console.log(`Group ${index}:`, {
					id: group.id,
					name: group.name,
					subgroup: group.subgroup,
					parentid: group.parentid
				})
			})
			return response.list
		}

		// 직접 배열인 경우
		if (Array.isArray(response)) {
			console.log('Groups array:', response.length, response)
			return response
		}

		console.log('No groups found')
		return []
	}, [response])

	return {
		groups,
		isLoading,
		error,
		refresh: mutate
	}
}